<div class="spectrum" aria-hidden="true">
  @for (bar of bars; track $index) {
    <span class="spectrum__bar" [class.spectrum__bar--hi]="bar.hi" [style.height.%]="bar.height * 100"></span>
  }
</div>
